class ValidationService {
  validateCustomerInfo(customerInfo) {
    const errors = [];
    
    console.log('Validation customerInfo:', customerInfo);
    
    // Validation du prénom
    if (!customerInfo.firstName || customerInfo.firstName.trim().length < 2) {
      errors.push('Le prénom doit contenir au moins 2 caractères');
    }
    
    // Validation du nom
    if (!customerInfo.lastName || customerInfo.lastName.trim().length < 2) {
      errors.push('Le nom doit contenir au moins 2 caractères');
    }
    
    // Validation de l'email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!customerInfo.email || !emailRegex.test(customerInfo.email)) {
      errors.push('Veuillez entrer une adresse email valide');
    }
    
    // Validation du téléphone (très flexible - accepte tous les formats ivoiriens)
    const cleanPhone = customerInfo.phone.replace(/\D/g, ''); // Garder seulement les chiffres
    
    // Accepter: 712918220, 0712918220, +225712918220, 00225712918220
    if (!customerInfo.phone || (
      cleanPhone.length !== 8 &&  // Format ivoirien sans code pays
      cleanPhone.length !== 10 && // Format avec 0 au début
      cleanPhone.length !== 12    // Format avec code pays
    )) {
      errors.push('Veuillez entrer un numéro de téléphone ivoiren valide');
    }
    
    // Validation de l'adresse (temporairement désactivée pour les tests)
    // if (!customerInfo.address || customerInfo.address.trim().length < 5) {
    //   errors.push('Veuillez entrer une adresse complète');
    // }
    
    // Validation de la ville
    if (!customerInfo.city || customerInfo.city.trim().length < 2) {
      errors.push('Veuillez entrer une ville');
    }
    
    // Normalisation du téléphone
    let normalizedPhone = customerInfo.phone;
    if (normalizedPhone) {
      // Supprimer tous les caractères non numériques
      const digitsOnly = normalizedPhone.replace(/\D/g, '');
      
      // Ajouter le code pays +225 si ce n'est pas déjà un numéro international
      if (!normalizedPhone.startsWith('+')) {
        if (digitsOnly.length === 8) {  // Numéro ivoirien sans code pays
          normalizedPhone = '+225' + digitsOnly;
        } else if (digitsOnly.length === 10 && digitsOnly.startsWith('0')) {  // Format ivoirien avec 0 au début
          normalizedPhone = '+225' + digitsOnly.substring(1);  // Enlever le 0 et ajouter +225
        } else {
          normalizedPhone = '+' + digitsOnly;  // Par défaut, ajouter +
        }
      } else {
        // Garde le format international existant
        normalizedPhone = '+' + digitsOnly;
      }
      
      console.log(`Téléphone normalisé: ${normalizedPhone} (original: ${customerInfo.phone})`);
    }
    
    return {
      valid: errors.length === 0,
      errors,
      normalizedPhone
    };
  }
  
  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
  validatePhone(phone) {
    const phoneRegex = /^(\+225|00225)?[0][1-7]\d{8}$|^(\+225|00225)?[1-7]\d{8}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  }
}

const validationService = new ValidationService();
export { validationService };
